import { Grid } from '@mui/material'
import { useContext } from 'react'
import { CustomHTMLSelect } from 'src/consumer/components/helperComponents'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import {
  GenericTimerHtmlSelectOptionStyled,
  GenericTimerHtmlSelectStyled,
} from './styledComponents'
import { BELL_TYPES_OPTIONS } from './utils'

export default function BellTypeDropDown({ bellType, handleChange }) {
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const bellTypes = unSecureSetupData?.bellTypes || BELL_TYPES_OPTIONS?.map((type) => type?.id)

  return (
    <Grid xs={12} item>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
        }}
      >
        <span style={{ flexShrink: 0, margin: 0 }}>Bell Type</span>
        <CustomHTMLSelect
          id="bellType"
          value={bellType}
          options={bellTypes?.map((type) => {
            const foundBellType = BELL_TYPES_OPTIONS?.find(
              (constBellType) => constBellType?.id === type,
            )
            return foundBellType || { id: type, title: type }
          })}
          getOptionValue={(opt) => opt?.id}
          getOptionLabel={(opt) => opt?.title}
          onChange={handleChange}
          selectComponent={GenericTimerHtmlSelectStyled}
          optionComponent={GenericTimerHtmlSelectOptionStyled}
          outerMostDivStyle={{ width: '100%' }}
        />
      </div>
    </Grid>
  )
}
